import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/case/")({
	beforeLoad: () =>
		// @ts-expect-error
		redirect({ to: "/dashboard/case/$status", params: { status: "active" } }),
});
